import React from 'react';
import { Box, Typography, ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChatBotStore } from '../../stores/chatBotStore';
import { SupportedActionsData } from './types';

const useStyles = makeStyles((theme) => ({
  messageText: {
    fontSize: '15px',
    lineHeight: '1.6',
    marginBottom: theme.spacing(1.5),
  },
  sectionHeader: {
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  actionButton: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(1.25, 2),
    borderRadius: '20px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    textAlign: 'left',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: 'rgba(33, 57, 94, 0.04)',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(33, 57, 94, 0.15)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  },
  actionName: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  actionHint: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
    marginTop: '2px',
  },
  footer: {
    fontSize: '15px',
    lineHeight: '1.6',
    marginTop: theme.spacing(2),
  },
}));

interface SupportedActionsProps {
  data: SupportedActionsData;
  store: ChatBotStore;
}

export const SupportedActions: React.FC<SupportedActionsProps> = ({ data, store }) => {
  const classes = useStyles();

  return (
    <Box>
      {data.message && (
        <Typography className={classes.messageText}>{data.message}</Typography>
      )}
      {data.sections.map((section, sectionIndex) => (
        <Box key={sectionIndex}>
          <Typography className={classes.sectionHeader}>{section.sectionName}</Typography>
          <Box className={classes.actionsContainer}>
            {section.actions.map((action, actionIndex) => (
              <ButtonBase
                key={actionIndex}
                className={classes.actionButton}
                onClick={() => store.sendMessage(action.name)}
              >
                <Typography className={classes.actionName}>{action.name}</Typography>
                {action.hint && (
                  <Typography className={classes.actionHint}>{action.hint}</Typography>
                )}
              </ButtonBase>
            ))}
          </Box>
        </Box>
      ))}
      {data.footer && (
        <Typography className={classes.footer}>{data.footer}</Typography>
      )}
    </Box>
  );
};
